<div class="article-container">
  <img
    [src]="articlePreview.mainPhoto?.url ?? '/assets/images/blog_default_photo_lg.jpg'"
    onerror="this.src='/assets/images/blog_default_photo_lg.jpg';"
    [attr.alt]="articlePreview.mainPhoto?.alt ?? ''"
    data-cy="desktop-featured-top-main-photo"
  />

  <div>
    <div class="article-heading">
      {{ articlePreview.title }}
    </div>
    <div class="article-info">
      <svg-icon src="assets/icons/calendar.svg" [svgStyle]="{ 'width.px':27, 'height.px':28 }" svgClass="svg-icon-calendar"></svg-icon>
      <span>{{ articlePreview.publishOn | date:'d. M. y' }}</span>
      <svg-icon src="assets/icons/eye.svg" [svgStyle]="{ 'width.px':50, 'height.px':45 }" svgClass="svg-icon-eye"></svg-icon>
      <span>{{ articlePreview.readingTime ? articlePreview.readingTime : 0 }} min</span>
    </div>
    <div class="article-text">
      {{ articlePreview.perex }}
    </div>
  </div>
</div>
